import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationsService } from './notifications.service';
import { NotificationModel } from './notifications';
import * as _ from 'lodash';
import { IdbService } from 'src/app/services/idb.service';
import { environment } from 'src/environments/environment';
import { IdbNotificationsResponse } from 'src/app/model/idb';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-notifications-center',
  templateUrl: './notifications-center.component.html',
  styleUrls: ['./notifications-center.component.scss']
})
export class NotificationsCenterComponent implements OnInit, OnDestroy{

  oldNotif: NotificationModel[] = [];

  newNotif: NotificationModel[] = [];
  ready: boolean = false;

  constructor(private notifications: NotificationsService, private idb:IdbService, private localStorageS:LocalStorageService){

  }

  ngOnInit(): void {
    let session = this.localStorageS.getSession();
    this.idb.getAllData(environment.idbTables.Notifications).then((data:IdbNotificationsResponse[])=>{

      data.filter(x=> x.item.userId == session?.id && x.item.viewed == true).forEach(notif=>{
        console.warn(notif)
        this.oldNotif.push(notif.item);
      });

      data.filter(x=> x.item.userId == session?.id && x.item.viewed == false).forEach(notif=>{
        console.warn(notif)
        this.newNotif.push(notif.item);
      });
      
    })

    this.notifications.markAsViewedNotifications();

  }


  ngOnDestroy(): void {
  
  }

}
